/**
 * HSFC shows errors outside predictable CSS hooks; we set data-hsfc-border on
 * .hsfc-TextInput and let _script-text-bg.scss style valid / error.
 */
const rendererSel = '[data-hsfc-id="Renderer"]';
const fieldSel = ".hsfc-TextInput";
const controlSel =
  "input:not([type='hidden']):not([type='checkbox']):not([type='radio']), textarea, select";
const errorSel = '[class*="Error"], [class*="error"], [role="alert"]';

const observed = new WeakSet();

function visible(el) {
  const s = window.getComputedStyle(el);
  return s.display !== "none" && s.visibility !== "hidden";
}

function fieldWrapper(field) {
  return (
    field.closest('[data-hsfc-id="FormField"]') ||
    field.closest('[class*="hsfc-FormField"]') ||
    field.closest('[class*="hsfc-Field"]') ||
    field.parentElement
  );
}

function controlFor(field) {
  const w = fieldWrapper(field);
  return field.querySelector(controlSel) || (w && w.querySelector(controlSel));
}

function setState(field, state) {
  if (state) field.setAttribute("data-hsfc-border", state);
  else field.removeAttribute("data-hsfc-border");
}

function applyValidity(field) {
  const c = controlFor(field);
  if (!c) {
    setState(field, null);
    return;
  }
  if (c.value.trim() && c.validity.valid) setState(field, "valid");
  else setState(field, null);
}

function fieldForError(err, renderer) {
  const wrap = err.closest(
    '[data-hsfc-id="FormField"], [class*="hsfc-FormField"], [class*="hsfc-Field"]'
  );
  const inWrap = wrap && wrap.querySelector(fieldSel);
  if (inWrap) return inWrap;
  const fields = Array.from(renderer.querySelectorAll(fieldSel));
  return fields
    .filter((f) => f.compareDocumentPosition(err) & Node.DOCUMENT_POSITION_FOLLOWING)
    .pop();
}

function sync(renderer) {
  renderer.querySelectorAll(fieldSel).forEach(applyValidity);
  renderer.querySelectorAll(errorSel).forEach((err) => {
    if (!visible(err)) return;
    const field = fieldForError(err, renderer);
    if (field) setState(field, "error");
  });
}

function attach(renderer) {
  if (observed.has(renderer)) return;
  observed.add(renderer);
  sync(renderer);
  new MutationObserver(() => sync(renderer)).observe(renderer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "aria-invalid"],
  });
}

function onInput(e) {
  if (!e.target.closest) return;
  const wrap = e.target.closest(
    '[data-hsfc-id="FormField"], [class*="hsfc-FormField"], [class*="hsfc-Field"]'
  );
  const field =
    e.target.closest(fieldSel) || (wrap && wrap.querySelector(fieldSel));
  if (field && field.closest(rendererSel)) applyValidity(field);
}

function boot() {
  document.querySelectorAll(rendererSel).forEach(attach);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}

["input", "change", "blur"].forEach((ev) =>
  document.addEventListener(ev, onInput, true)
);

window.addEventListener("hs-form-event:on-ready", () => {
  document.querySelectorAll(rendererSel).forEach(attach);
});
